import { Box } from '@mui/material';

export const Ledger = () => {
    return <Box sx={{ flex: 1 }}>GENERAL LEDGER</Box>;
};
